import { makeStyles, createStyles } from '@material-ui/core';

const AppStylesheet = makeStyles(() => createStyles({
  mainContainer: {
    height: "100%"
  }
}));

export default AppStylesheet;